/* Quantité de la fiche produit */
(function () {
  var o = document.getElementById('f4-qo'), i = document.getElementById('f4-qv');
  if (!o || !i) return;
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-qd]');
    if (!b) return;
    var n = Math.max(1, Math.min(99, (parseInt(i.value, 10) || 1) + parseInt(b.getAttribute('data-qd'), 10)));
    i.value = n; o.textContent = n;
  });
})();

/* Aperçus des cartes de l'atelier : les GIF alternent, un objet à la fois, en fondu (image préchargée avant l'échange) */
function f4SwapGifs(root) {
  if (window.matchMedia && matchMedia('(prefers-reduced-motion:reduce)').matches) return;
  [].slice.call(root.querySelectorAll('[data-pool]')).forEach(function (p, pi) {
    var pool; try { pool = JSON.parse(p.getAttribute('data-pool')); } catch (e) { return; }
    var imgs = [].slice.call(p.querySelectorAll('img')); if (pool.length <= imgs.length) return;
    var turn = 0;
    function tick() {
      if (document.hidden || !p.offsetParent) return;
      var im = imgs[turn++ % imgs.length], cur = imgs.map(function (x) { return x.getAttribute('src'); });
      var free = pool.filter(function (u) { return cur.indexOf(u) < 0; }), n = free[Math.floor(Math.random() * free.length)];
      var pre = new Image(); pre.onload = function () { im.style.opacity = 0; setTimeout(function () { im.src = n; im.style.opacity = 1; }, 400); }; pre.src = n;
    }
    setTimeout(function () { tick(); setInterval(tick, 3000); }, 1200 + pi * 700);
  });
}
f4SwapGifs(document);

/* Panier : rotation 3D très légère et fluide. Deux vues voisines de la planche sont mélangées en continu (le nombre de vues est lu dans l'image). */
(function () {
  var els = [].slice.call(document.querySelectorAll('.f4-spin'));
  if (!els.length || (window.matchMedia && matchMedia('(prefers-reduced-motion:reduce)').matches)) return;
  var PERIOD = 9000, ready = [];
  function pos(i, n) { return (i * 100 / (n - 1)) + '% 0'; }
  els.forEach(function (el) {
    var m = /url\((.*)\)/.exec(el.style.backgroundImage || '');
    if (!m) return;
    var im = new Image();
    im.onload = function () {
      var n = Math.max(2, Math.round(im.naturalWidth / im.naturalHeight));
      var b = document.createElement('div');
      b.className = 'f4-spin2'; b.style.backgroundImage = el.style.backgroundImage;
      el.style.backgroundSize = b.style.backgroundSize = (n * 100) + '% 100%';
      el.appendChild(b); el.classList.add('f4-js'); el._b = b; el._n = n; ready.push(el);
    };
    im.src = m[1].replace(/^["']|["']$/g, '');
  });
  function tick(now) {
    var c = 1 - Math.cos(2 * Math.PI * now / PERIOD);
    ready.forEach(function (el) {
      var n = el._n, t = (n - 1) / 2 * c, i = Math.min(n - 2, Math.floor(t)), f = t - i;
      el.style.backgroundPosition = pos(i, n);
      el._b.style.backgroundPosition = pos(i + 1, n);
      el._b.style.opacity = f.toFixed(3);
    });
    requestAnimationFrame(tick);
  }
  requestAnimationFrame(tick);
})();
